/** URL prefixes are routing hints only. On custom domains the backend resolves
 *  the merchant from the host; links must keep an empty public prefix. */
const RESERVED = new Set(["api", "master", "admin", "login", "register", "portal", "dealer", "plots",
  "dashboard", "settings", "ledger", "customer-ledger", "booking-dashboard", "sister-companies",
  "receipt", "static", "assets", "docs", "redoc", "uploads", "webhooks", "book", "website", "health",
  "favicon.ico", "manifest.json", "robots.txt", "asset-manifest.json", "jobs"]);

const CODE_RE = /^[a-z0-9]([a-z0-9-]{0,38}[a-z0-9])?$/;

const first = window.location.pathname.split("/")[1] || "";

export const MERCHANT_CODE = !RESERVED.has(first) && CODE_RE.test(first) ? first : "";
export const ROUTER_BASENAME = MERCHANT_CODE ? `/${MERCHANT_CODE}` : "/";

/** Prefix an app path with the merchant code when the app is served from /{merchant-code}. */
export const tenantPath = (path = "/") => {
  if (!MERCHANT_CODE) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const prefix = `/${MERCHANT_CODE}`;
  if (normalized === prefix || normalized.startsWith(`${prefix}/`)
    || normalized.startsWith(`${prefix}?`) || normalized.startsWith(`${prefix}#`)) return normalized;
  return `${prefix}${normalized}`;
};
